module.exports = __webpack_public_path__ + "static/logo-1f03dc172559f61dad0008dc983a05cc.png";